export default __webpack_public_path__ + "images/6B.6aa84e1.png";